export const DEFAULT_STRING = 'defaultString';
